<small class="debug">{{me}}</small>
<div class="form">
  <ng-template insert-directive></ng-template>
</div>
